import Vue from 'vue'
import Router from 'vue-router'
import { Login } from '@/pages/login';
import { Users } from '@/pages/users';
import { course } from '@/pages/course';
import { Navbar,  Dashboard } from '@/pages/dashboard';
import Firebase from '../lib/Firebase';
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/app',
      name: 'Navbar',
      component: Navbar,
      children: [
        {
          path: '/app/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/app/users',
          name: 'Users',
          component: Users
        },
        {
          path: '/app/course',
          name: 'course',
          component: course
        },
      
      
      ]
    
    },
  ]
})
router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    next();
  }

  Firebase.auth().onAuthStateChanged((user) => {
    if (!user) {
      next('/');
    } else {
      next();
    }
  });
});
export default router;  


// WEBPACK FOOTER //
// ./src/router/index.js